export default __webpack_public_path__ + "static/media/icon-business-model-hybrid.3d9d7c50.svg";